// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

const uri = "api/custom/geolocation/GetNearestWarehouse";

type WarehouseResult = {
    name: string;
    id: string;
    successful: boolean;
    message?: string;
};

export async function getWarehouse(params: any) {
    const guestPostalCode = params.guestPostalCode;
    try {
        const result = await get<WarehouseResult>(`${uri}?guestPostalCode=${guestPostalCode}`);
        return {
            successful: true,
            id: result.id,
            name: result.name,
        };
    } catch (error) {
        return {
            successful: false,
            message: "Warehouse Not Found",
        };
    }
}
